import { render, staticRenderFns } from "./OrderItemModal.vue?vue&type=template&id=374bce62&"
import script from "./OrderItemModal.vue?vue&type=script&lang=js&"
export * from "./OrderItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports